// Date 2021-06-28 18:04:55

import emSicEafmREocEmrec from "@/store/em/statusCollection/EmSicEafmREocEmrecStore.js";
import emSicMonitorPointSmp from "@/store/em/statusCollection/EmSicMonitorPointSmpStore.js";
import emSicUploadFileSuf from "@/store/em/statusCollection/EmSicUploadFileSufStore.js";
import emSicBoardModuleSdm from "@/store/em/statusCollection/EmSicBoardModuleSdmStore.js";
import emSicBoardPointSdp from "@/store/em/statusCollection/EmSicBoardPointSdpStore.js";
import imfSicEquipmentInfoIsei from "@/store/em/statusCollection/ImfSicEquipmentInfoIseiStore.js";
import emSicDowntimeRecordSdr from "@/store/em/statusCollection/EmSicDowntimeRecordSdrStore";
import emSicBoardLifeCycleSdl from "@/store/em/statusCollection/EmSicBoardLifeCycleSdlStore.js";
import imfEmSicEqStatusMoniRecoIesmr from "@/store/em/statusCollection/ImfEmSicEqStatusMoniRecoIesmrStore.js";
import imfEmSicIesmrReasonIesmrr from "@/store/em/statusCollection/ImfEmSicIesmrReasonIesmrrStore.js";
import imfEmSicIesmrStatusIesmrs from "@/store/em/statusCollection/ImfEmSicIesmrStatusIesmrsStore.js";
import emSicBackgroundImageSbi from "@/store/em/statusCollection/EmSicBackgroundImageSbiStore.js";
import emSicCustomizedDiagramScd from "@/store/em/statusCollection/EmSicCustomizedDiagramScdStore.js";
import emSicCustomizedDiagramPieceCdp from "@/store/em/statusCollection/EmSicCustomizedDiagramPieceCdpStore.js";
import tpmMonitorSpindleLoadTms from "@/store/em/statusCollection/TpmMonitorSpindleLoadTmsStore.js";
import tpmMonitorProgramStatusTmp from "@/store/em/statusCollection/TpmMonitorProgramStatusTmpStore.js";
import tpmOeeReportTor from "@/store/em/statusCollection/TpmOeeReportTorStore.js";
import tpmOeeSpindleDataFetch from "@/store/em/statusCollection/TpmOeeSpindleDataFetchStore.js";
import tpmOeeQueryHistoryToh from "@/store/em/statusCollection/TpmOeeQueryHistoryTohStore.js";
import tpmOeeDashboardConfig from "@/store/em/statusCollection/TpmOeeDashboardConfigStore.js";
import tpmMonitorOperateModeTmo from "@/store/em/statusCollection/TpmMonitorOperateModeTmoStore.js";
import tpmMonitorProgramStatusTmo from "@/store/em/statusCollection/TpmMonitorProgramStatusTmoStore.js";
import tpmAxisCoordinateDataAcd from "@/store/em/statusCollection/TpmAxisCoordinateDataAcdStore.js";
import tpmTsdOpcConfigTtc from "@/store/em/statusCollection/TpmTsdOpcConfigTtcStore.js";

const genericEntities = [
    'emSicEafmREocEmrec',
    'emSicMonitorPointSmp',
    'emSicUploadFileSuf',
    'emSicBoardModuleSdm',
    'emSicBoardPointSdp',
    'emSicBoardLifeCycleSdl',
    'imfSicEquipmentInfoIsei',
    'emSicDowntimeRecordSdr',
    'imfEmSicEqStatusMoniRecoIesmr',
    'imfEmSicIesmrReasonIesmrr',
    'imfEmSicIesmrStatusIesmrs',
    'emSicBackgroundImageSbi',
    'emSicCustomizedDiagramScd',
    'emSicCustomizedDiagramPieceCdp',
    'tpmMonitorSpindleLoadTms',
    'tpmMonitorProgramStatusTmp',
    'tpmOeeReportTor',
    'tpmOeeSpindleDataFetch',
    'tpmOeeQueryHistoryToh',
    'tpmOeeDashboardConfig',
    'tpmMonitorOperateModeTmo',
    'tpmMonitorProgramStatusTmo',
    'tpmAxisCoordinateDataAcd',
    'tpmTsdOpcConfigTtc'
]

const entities = {
    emSicEafmREocEmrec,
    emSicMonitorPointSmp,
    emSicUploadFileSuf,
    emSicBoardModuleSdm,
    emSicBoardPointSdp,
    emSicBoardLifeCycleSdl,
    imfSicEquipmentInfoIsei,
    emSicDowntimeRecordSdr,
    imfEmSicEqStatusMoniRecoIesmr,
    imfEmSicIesmrReasonIesmrr,
    imfEmSicIesmrStatusIesmrs,
    emSicBackgroundImageSbi,
    emSicCustomizedDiagramScd,
    emSicCustomizedDiagramPieceCdp,
    tpmMonitorSpindleLoadTms,
    tpmMonitorProgramStatusTmp,
    tpmOeeReportTor,
    tpmOeeSpindleDataFetch,
    tpmOeeQueryHistoryToh,
    tpmOeeDashboardConfig,
    tpmMonitorOperateModeTmo,
    tpmMonitorProgramStatusTmo,
    tpmAxisCoordinateDataAcd,
    tpmTsdOpcConfigTtc
}

export {genericEntities}

export default entities
